import {
  pageViewSrc10Evid5000,
  ggGeneralActionSrc10Evid5001,
  ggActionInTypingConsoleSrc10Evid5002,
  ggCreateAiStoreFinishFlowSrc10Evid5003,
} from '@wix/bi-logger-stores-data/v2';
import {
  pageViewSrc10Evid5000Params,
  ggGeneralActionSrc10Evid5001Params,
  ggActionInTypingConsoleSrc10Evid5002Params,
  ggCreateAiStoreFinishFlowSrc10Evid5003Params,
} from '@wix/bi-logger-stores-data/v2/types';
import { ReportProps } from '@wix/web-bi-logger/dist/src/types';
import { useBILogger } from '@wix/fe-essentials-standalone';
import { BI_CONSTANTS } from './biConstants';
import { getReferralInfo, useBiScreen } from './useBiContext';
import { useSessionId } from '../useSessionId';
import { useMsIdAtomValue } from '../../context/dsUserInsights';

const { FLOWS } = BI_CONSTANTS;

interface ActionClickedParams {
  action: string;
  button_name: string;
  value?: string;
}

interface ActionConsoleParams {
  action: string;
  questionContent: string;
  value: string;
  clicked_send: boolean;
}

export const useBiLogger = () => {
  const bi = useBILogger();
  const { screen } = useBiScreen();
  const metaSiteId = useMsIdAtomValue();
  const sessionId = useSessionId();

  const getPageViewFields = () => {
    return {
      flow: FLOWS.DS,
      msId: metaSiteId,
    };
  };

  const baseAppContextFields = () => {
    return {
      flow: FLOWS.DS,
      profileId: sessionId,
    };
  };

  const appContextFields = () => {
    return {
      ...baseAppContextFields(),
      screenName: screen.name,
    };
  };

  const report = (payload: ReportProps) => {
    const action = `${payload.src}:${payload.evid}`;
    debugReport(action, payload.params);
    return bi.report(payload);
  };

  const debugReport = (action: string, params: any) => {
    console.debug(`bi report ${action}`, params);
  };

  return {
    scrollChat(scrollTop: number) {
      debugReport('scrollChat', scrollTop);
    },
    back(string: string) {
      debugReport('back', string);
    },
    pageView(pageName: string) {
      const referral_info = getReferralInfo();
      const params: pageViewSrc10Evid5000Params = { pageName, referral_info, ...getPageViewFields() };

      void report(pageViewSrc10Evid5000(params));
    },
    actionClicked(actionClickedParams: ActionClickedParams) {
      const params: ggGeneralActionSrc10Evid5001Params = {
        ...actionClickedParams,
        ...appContextFields(),
      };
      void report(ggGeneralActionSrc10Evid5001(params));
    },

    actionInTypingConsole(params: ActionConsoleParams) {
      const reportParams: ggActionInTypingConsoleSrc10Evid5002Params = {
        ...params,
        ...baseAppContextFields(),
      };
      void report(ggActionInTypingConsoleSrc10Evid5002(reportParams));
    },
    generateSite(target_url: string) {
      const reportParams: ggCreateAiStoreFinishFlowSrc10Evid5003Params = {
        target_url,
        ...baseAppContextFields(),
      };
      void report(ggCreateAiStoreFinishFlowSrc10Evid5003(reportParams));
    },
  };
};
